<template>
  <div>
    <div class="has-bg-white is-border is-radius-large is-margin-top">
      <div class="is-padding-top is-padding-left is-padding-right is-margin-top">
        <div class="title is-4">Évolution des réservations</div>
      </div>
      <div class="is-padding">
        <sales-chart v-if="saleEntities && saleEntities.length"
                     :entities="saleEntities"
                     :entity-key="'sales'"
                     :date-param="'reservation_date'"
                     :chart-name="'Nombre de ventes'"
                     :team-count="teamCount"
                     :period="period"></sales-chart>
      </div>
    </div>

    <div v-if="!userIsExternal" class="columns">
      <div class="column is-12 is-paddingless-bottom is-paddingless-left is-paddingless-right">
        <div class="has-bg-white is-border is-radius-large">
          <div class="is-padding-top is-padding-left is-padding-right is-margin-top">
            <div class="title is-4">Évolution des rendez-vous</div>
          </div>
          <div class="is-padding">
            <rdvs-chart v-if="checkEmpty(rdvEntities)"
                        :entities="rdvEntities"
                        :entity-key="'rdvs'"
                        :date-param="'date'"
                        :chart-name="'Nombre de rdvs'"
                        :custom-name="rdvTypeName"
                        :chart-type="'column'"
                        :height="'350px'"
                        :period="period"></rdvs-chart>
          </div>
        </div>
      </div>
      <!-- <div class="column is-5 is-paddingless-bottom is-paddingless-right"
            v-if="dispositifsEntities && dispositifsEntities.length">
        <div class="has-bg-white is-border is-radius-large">
          <div class="is-padding is-margin-top"><div class="title is-4">Dispositifs</div></div>
          <div class="is-padding">
            <dispositif-radar :entities="dispositifsEntities"
                              :entity-key="'sales'"
                              :entity-param="'dispositif'"
                              :chart-name="'Dispositifs'"
                              :custom-name="dispositifsName"
                              :chart-type="'radar'"
                              :height="'350px'"></dispositif-radar>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { orderBy, isEmpty } from 'lodash'
  import { DefaultValues } from '@/mixins'
  import RdvsChart from './Charts/RdvsChart'
  import DispositifRadar from './Charts/DispositifRadar'
  import SalesChart from './Charts/SalesChart'

  export default {
    name: 'UserChartsPane',
    mixins: [DefaultValues],
    components: {
      RdvsChart,
      DispositifRadar,
      SalesChart
    },
    props: {
      user: {
        type: Object,
        required: true
      },
      sales: {
        type: Array,
        default: []
      },
      rdvs: {
        type: Array,
        default: []
      },
      startDate: {
        type: [Date, Object]
      },
      endDate: {
        type: [Date, Object]
      },
      teamCount: {
        type: Number,
        required: true
      }
    },
    computed: {
      userIsExternal () {
        return this.user.is_external
      },
      saleEntities () {
        let tmpDict = {}
        let addKey = function (entityPk, name) {
          tmpDict[entityPk] = {
            data: {
              sales: [],
              rdvs: []
            },
            pk: entityPk,
            name: name
          }
        }
        this.sales.forEach(sale => {
          let entityPk = sale.seller
          if ((entityPk in tmpDict) === false) {
            addKey(entityPk, sale.seller_name)
          }
          tmpDict[entityPk].data.sales.push(sale)
        })
        return orderBy(Object.values(tmpDict), 'pk', 'asc')
      },
      rdvEntities () {
        let tmpDict = {}
        let addKey = function (entityPk, name) {
          tmpDict[entityPk] = {
            data: {
              sales: [],
              rdvs: []
            },
            pk: entityPk,
            name: name
          }
        }
        if (this.rdvs && Array.isArray(this.rdvs) && this.rdvs) {
          this.rdvs.forEach(rdv => {
            let entityPk = rdv.seller
            if ((entityPk in tmpDict) === false) {
              addKey(entityPk, rdv.seller_name)
            }
            tmpDict[entityPk].data.rdvs.push(rdv)
          })
        }
        return [tmpDict[this.user.pk]]
      },
      period () {
        return this.getRangeOfDates(moment(this.startDate))
      }
    },
    methods: {
      sellerName (value) {
        if (value) {
          return `${value.first_name} ${value.last_name}`
        }
      },
      rdvTypeName (value) {
        if (value) {
          return value.rdv_type
        }
      },
      dispositifsName (value) {
        if (value) {
          return value.name
        }
      },
      checkEmpty (val) {
        return !isEmpty(val)
      },
      getRangeOfDates (start, arr = [start.startOf('month').format('YYYY-MM')]) {
        const next = moment(start).add(1, 'month').startOf('month')
        if (next.isAfter(this.endDate, 'month')) return arr
        return this.getRangeOfDates(next, arr.concat(next.format('YYYY-MM')))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserChartsPane.vue